import { IsoTimestamp, Uuid } from '../dto/common.js';
import { z } from '../zod.js';
import { INBOX_SUBJECT_KINDS, INBOX_CATEGORIES as ROWS } from './rows-inbox.js';
/**
 * The Inbox-category contract (baseline section 5 "Inbox: the one triage surface"; 1.0b
 * deliverable 12). The Inbox is one surface over registered queries: each category's owner
 * implements an {@link InboxCategoryQuery}, and the server lists and counts through them.
 * Reference documents never appear in a category (A2.1 section 4).
 */
export { INBOX_SUBJECT_KINDS };
export const INBOX_CATEGORIES = ROWS;
/** The category keys, in the table's order: also the values of `inbox_dismissal.kind`. */
export const INBOX_CATEGORY_KEYS = ROWS.map((row) => row.key);
export const InboxCategoryKey = z.enum(ROWS.map((row) => row.key));
export const InboxSubjectKind = z.enum(INBOX_SUBJECT_KINDS);
/** A capture's text: one note of at most 2,000 characters, not blank (`inbox.capture`). */
export const InboxCaptureText = z.string().min(1).max(2000).regex(/\S/);
/**
 * One Inbox row: its subject, why it is here, and the label of its one primary action. CS r2c
 * (DECISIONS 144) adds, each optional so a category built before it still compiles:
 * - `docId` and `blockId` (N1, nullable): the page and block the row's primary button opens, which
 *   1.N-3 fills for link warnings, chronology violations, lost anchors and pending images; null or
 *   absent, the row has no primary button;
 * - `text` (N2, nullable): a capture's text, bounded as `InboxCaptureRequestV1.text`, set only on a
 *   `capture` row, so filing it can make a page of it.
 */
export const InboxItemV1 = z
    .strictObject({
    category: InboxCategoryKey,
    subjectId: Uuid,
    subjectKind: InboxSubjectKind,
    title: z.string().min(1).max(500),
    reason: z.string().min(1).max(500),
    primaryAction: z.string().min(1).max(100),
    createdAt: IsoTimestamp,
    docId: Uuid.nullable().optional(),
    blockId: Uuid.nullable().optional(),
    text: InboxCaptureText.nullable().optional(),
})
    .refine((item) => item.text === undefined || item.text === null || item.category === 'capture', {
    message: 'only a capture carries text',
    path: ['text'],
});
//# sourceMappingURL=categories.js.map